// extracted by mini-css-extract-plugin
export default {"oscarSearchWidget":"uDOjJCt8ZwTnwqU1igfG__oscarSearchWidget___"};